module.exports = __webpack_public_path__ + "static/media/news-cdphp-covid-article.9303e113.jpg";